import { ResponseWrapper } from '../types/base.types'
import type {
  VkIntegrationGetConfigData,
  VkTestConnectionData,
} from './vk/vk.types'

export const CRM_INTEGRATION_NAME = {
  VKONTAKTE: 'vkontakte',
  MAX: 'max',
  PODPISLON: 'podpislon',
} as const

export type CrmIntegrationName =
  (typeof CRM_INTEGRATION_NAME)[keyof typeof CRM_INTEGRATION_NAME]

/** Успешный GET /integration/get-config?name=vkontakte */
export type ResponseVkIntegrationConfig =
  ResponseWrapper<VkIntegrationGetConfigData>

export type MaxIntegrationConfigFields = {
  api_key?: string
  bot_id?: string
  is_active?: boolean
  code_ttl_minutes?: number
  resend_timeout_seconds?: number
  message_template?: string
  dev_webhook_url?: string
}

export type MaxIntegrationGetConfigData = {
  name?: string
  label?: string
  description?: string
  category?: string
  fields?: MaxIntegrationConfigFields | string | null
  created_at?: string
  updated_at?: string
}

export type MaxIntegrationUpdateConfigData = {
  status?: 'success' | 'error' | string
  message?: string
  fields?: MaxIntegrationConfigFields | string | null
}

export type MaxIntegrationUpdateConfigBody = {
  fields: Required<MaxIntegrationConfigFields>
}

export type ResponseMaxIntegrationConfig =
  ResponseWrapper<MaxIntegrationGetConfigData>

export type ResponseMaxIntegrationUpdateConfig =
  ResponseWrapper<MaxIntegrationUpdateConfigData>

/** POST /integration/test-connection?name=vkontakte */
export type ResponseVkTestConnection = ResponseWrapper<VkTestConnectionData>

/** Успешный PUT /integration/update-config */
export type ResponseUpdateIntegrationConfig = ResponseWrapper<string>
